export default __webpack_public_path__ + "static/media/environment-plane-travel.c8926ca6.png";